export const SET_ALL_DEALS = 'SET_ALL_DEALS';
export const SET_CUSTOMER_TYPES = 'SET_CUSTOMER_TYPES';
export const SET_POWER_MEASUREMENT = 'SET_POWER_MEASUREMENT';
export const SET_CONSUMPTION_TYPE = 'SET_CONSUMPTION_TYPE';
export const SET_DISTRIBUTORS = 'SET_DISTRIBUTORS';
export const SET_SUPPLIERS = 'SET_SUPPLIERS';
export const SET_DISTRIBUTOR = 'SET_DISTRIBUTOR';
export const SET_CUSTOMER_TYPE = 'SET_CUSTOMER_TYPE';
export const SET_ACTIVE_HT = 'SET_ACTIVE_HT';
export const SET_ACTIVE_LT = 'SET_ACTIVE_LT';
export const SET_METER_TYPE = 'SET_METER_TYPE';
export const SET_SORT = 'SET_SORT';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_NAVIGATION_LINKS = 'SET_NAVIGATION_LINKS';
export const SET_STATIC_CONTENT = 'SET_STATIC_CONTENT';
export const TOGGLE_NAVIGATION_DRAWER = 'TOGGLE_NAVIGATION_DRAWER';
export const SET_IS_SCROLLED_TO_FOOTER = 'SET_IS_SCROLLED_TO_FOOTER';
export const GET_WINDOW_WIDTH = 'GET_WINDOW_WIDTH';
export const GET_WINDOW_HEIGHT = 'GET_WINDOW_HEIGHT';
export const SET_REACTIVE_HT = 'SET_REACTIVE_HT';
export const SET_REACTIVE_LT = 'SET_REACTIVE_LT';
export const SET_REACTIVE_ENERGY_TYPE = 'SET_REACTIVE_ENERGY_TYPE';
